// test1677
(1677 && 0);
